import { useEffect, useState } from "react";
import { ping as pingReq } from "sources/home";

export default function Ping() {
    const [ping, setPing] = useState("");
    useEffect(() => {
        pingReq().then(() => setPing("pong"));
    }, []);

    return ping;
}
